import { Space } from 'antd';
import styled from 'styled-components';

import Icon from '@asset/consumer.icon.svg?react';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const NewConsumerWrapper = styled.div`
  max-width: 286px;
  flex: 1;
`;

export const ConsumerButtonTitle = styled(Text).attrs((props) => ({
  color: props.theme.Title.colorConsumerButtonTitle,
}))``;

export const ConsumerIcon = styled(Icon)`
  fill: ${ColorEnum.Black100};
  width: 18px;
  height: 18px;
`;

export const FormWrapper = styled.div`
  padding-top: 24px;
`;

export const FooterWrapper = styled(Space).attrs({
  direction: 'horizontal',
})`
  padding-top: 24px;
`;
